<template>
  <div class="w-full grid grid-flow-col grid-cols-2 gap-x-6 items-center py-6 px-4">
    <div>
      <Input v-model="search" placeholder="Search by name or email" class="col-start-1 col-end-3" />
    </div>
    <div class="w-full">
      <a-pagination v-model:current="current" :total="500" :pageSize="50" @change="onChange" />
    </div>
  </div>
</template>

<script>
import debounce from "lodash.debounce";
import { ref, computed, watch } from "vue";
import { useStore } from "vuex";
import Input from "@/components/UI/Input";

export default {
  components: { Input },
  setup() {
    const store = useStore();
    const totalUserCount = computed(() => store.state.totalUserCount);
    const current = ref(1)
    const search = ref("");

    watch(
      [search, current],
      debounce(() => {
        getUsers();
      }, 1500)
    );

    const getUsers = () => {
      store.commit("SET_PAGE", 0);
      store.commit("SET_USERS", null);
      store.dispatch("GET_USERS", {
        search: search.value ? search.value : undefined,
        page: current.value
      });
    };

    const resetFilters = () => {
      search.value = null;

      store.commit("SET_FILTERS", {});
      store.commit("SET_PAGE", 0);
      store.commit("SET_USERS", null);
      store.dispatch("GET_USERS");
    };
    const onChange = (pageNumber) => {
      store.commit('SET_PAGE', pageNumber)
    }
    return {
      search,
      getUsers,
      resetFilters,
      totalUserCount,
      current,
      onChange
    };
  },
};
</script>

<style scoped>
.filters__item {
  @apply flex border-r border-gray-600 py-0 px-3 mr-2 cursor-pointer;
}

.filters__item svg {
  transition: 0.3s;
}

.filters__item:hover .check,
.filters__item .close {
  display: none;
}

.filters__item:hover .close {
  display: block;
}

.filters__item:hover .refresh {
  transform: rotate(60deg);
}
</style>
